export type OrgInt = {
    id: string
    name: string
    type: OrganizationIntegrationType
    googleTagManager?: {
        containerId?: string
    }
}

export enum OrganizationIntegrationType {
    // BITLY = 'BITLY',
    INSIGHTLY = 'INSIGHTLY',
    MAILCHIMP = 'MAILCHIMP',
    // EVENTBRITE = 'EVENTBRITE',
    STRIPE = 'STRIPE',
    OMNIVORE = 'OMNIVORE',
    HELIOS = 'HELIOS',
    RPOWER = 'RPOWER',
    SILVERWARE = 'SILVERWARE',
    GOOGLE_TAG_MANAGER = 'GOOGLE_TAG_MANAGER',
}